import { useCallback, useEffect, useRef, useState } from 'react';
import { RangeValue } from '../RangeInput';
import { PriceRangeArgs } from './PriceRange';
import { getVerifiedPriceRange } from '../../utils/priceRange';

export const usePriceRange = ({ value, onChange }: PriceRangeArgs) => {
  const previousValue = useRef<RangeValue>(value);
  const [currentValue, setCurrentValue] = useState<RangeValue>(value);
  const delay = useRef<NodeJS.Timeout>();

  const handleReset = useCallback(() => {
    setCurrentValue({ min: undefined, max: undefined });
  }, []);

  useEffect(() => {
    /**
     * If priceRange is removed from ActiveRefinementsBar, then reset the value
     */
    if (!value.min && !value.max && (previousValue.current.min || previousValue.current.max)) {
      previousValue.current = { ...value };
      setCurrentValue(value);
    }
  }, [value]);

  const handleChange = useCallback(
    (value: RangeValue) => {
      previousValue.current = currentValue;
      setCurrentValue(value);
      delay.current && clearTimeout(delay.current);
      delay.current = setTimeout(() => {
        const updatedValue = value.min !== previousValue.current.min ? 'min' : 'max';
        const verifiedRange = getVerifiedPriceRange(value, updatedValue);
        setCurrentValue(verifiedRange);
        onChange?.(verifiedRange);
      }, 500);
    },
    [currentValue, onChange]
  );

  return {
    currentValue,
    handleChange,
    handleReset
  };
};
